"use client"
import useSWR from "swr"

import type { MerchantOrderViewItem } from "@/app/[locale]/customer/orders/types"
import type { API_ROUTES_MERCHANT_ONGOING_ORDERS_RETURN } from "@/app/api/merchant/ongoing-orders/routeUtils"
import { API_ROUTES_MERCHANT_ONGOING_ORDERS } from "@/app/api/merchant/ongoing-orders/routeUtils"
import { useMerchantProfile } from "@/hooks/useGlobalStore"
import useSound from "use-sound"
import { useEffect, useRef } from "react"

export function useMerchantOngoingOrders(initialOrders: MerchantOrderViewItem[] = []) {
  const { merchantProfile } = useMerchantProfile()
  const [play] = useSound("/order-notification.m4a", {
    volume: 0.5,
  })
  const lastData = useRef(initialOrders)

  const fetcher = async () => {
    const res = await fetch(API_ROUTES_MERCHANT_ONGOING_ORDERS.get(merchantProfile.id))
    return (await res.json()) as API_ROUTES_MERCHANT_ONGOING_ORDERS_RETURN
  }

  const { data, mutate: invalidateOngoingOrders } = useSWR("ongoingOrders", fetcher, {
    refreshInterval: 1000,
  })
  const ongoingOrders = data ?? initialOrders
  useEffect(() => {
    if (
      lastData.current !== ongoingOrders &&
      ongoingOrders.length > 0 &&
      ongoingOrders.length > lastData.current.length
    ) {
      play()
    }
    if (ongoingOrders) {
      lastData.current = ongoingOrders
    }
  }, [ongoingOrders])
  return { ongoingOrders, invalidateOngoingOrders }
}
